  <template>
  <div class="users-style">

	<h3  style='font-size:24px;' class="my-5 text-center d-inline-block w-100">Please choose your desired period</h3>
  	<div v-if="success != ''" class="alert alert-success" role="alert"> {{success}} </div>

	<form class="clearfix" @submit="formSubmit" enctype="multipart/form-data">
		<input class="input" type="hidden" v-model="id" >
		<div class="row no-margin justify-content-center">
			<div class="col-md-4 float-left px-3">
				<div class="form-group">
					<label for="name" class="col-form-label">Select Payroll Fiscal Year</label>
					<div class="bv-no-focus-ring">
						<select id="year" v-model="year" name="year" required class="form-control custom-select" v-on:change="setfiscalyear()">
						    <option v-for='pyr in payrunyears'  :value='pyr.range'>{{ pyr.range }}</option>

						</select>
					</div>
				</div>
			</div>
			<div class="col-md-4 float-left px-3">
				<div class="form-group">
					<label for="status"  class="col-form-label">Select Payroll Month</label>
					<div class="bv-no-focus-ring">
						<select id="month" v-model="month" name="Month" required class="form-control custom-select" v-on:change="sendMessagetoParent()">
							<!--at_edit starts -->
							<option value="6">June {{year_segment2}}</option>
							<option value="5">May {{year_segment2}}</option>
							<option value="4">April {{year_segment2}}</option>
							<option value="3">March {{year_segment2}}</option>
							<option value="2">February {{year_segment2}}</option>
							<option value="1">January {{year_segment2}}</option>
							<option value="12">December {{year_segment1}}</option>
							<option value="11">November {{year_segment1}}</option>
							<option value="10">October {{year_segment1}}</option>
							<option value="9">September {{year_segment1}}</option>
							<option value="8">August {{year_segment1}}</option>
							<option value="7">July {{year_segment1}}</option>
							<!--at_edit ends -->
						</select>
					</div>
				</div>
			</div>
			<div class="col-md-12 px-3 text-center department-checkbox mt-4" v-if="this.get_payrun_parameter && this.get_payrun_parameter == 'department'">
				<template v-if="this.year && this.month">
					<h3 style="font-size: 15px;margin: 0 !important;padding-top: calc(0.375rem + 1px);padding-bottom: calc(0.375rem + 1px);text-align: left !important;line-height: 1.6;color: #004242;font-weight: 500;" class="m-4 text-center">Please choose departments</h3>
					<b-form-group label="" v-slot="{ ariaDescribedby }" class="px-3">
						<div class="department-select-all position-relative text-left px-2 custom-checkbox">
							<input type="checkbox" id="departmentAll" v-model="selectAll" class="custom-control-input" v-on:change="setDepartment()"/>
							<label class="custom-control-label" for="departmentAll"><span>Select All</span></label>
						</div>
						<b-form-checkbox-group id="department" class="row" v-model="department" :aria-describedby="ariaDescribedby" name="department" v-on:change="setDepartment()">
							<template v-for="department in departments">
								<b-form-checkbox class="col-md-6 mr-0" v-if="department.has_employee == 'no'" :value="department.id" :key="department.id" disabled><span v-if="department.payrun_processed == 'yes'" style="color: rgb(29, 104, 167);">{{department.name}} ({{department.employee_count}})</span><span v-else>{{department.name}} ({{department.employee_count}})</span> <b-icon v-if="department.payrun_processed == 'yes'" icon="check-circle-fill" class="ml-3 mt-1 float-right" variant="success"></b-icon><b-icon class="ml-2" icon="info-circle"  title="This department does not have any employee assigned" v-b-tooltip></b-icon></b-form-checkbox>
								<b-form-checkbox class="col-md-6 mr-0" v-else :value="department.id" :key="department.id"><span v-if="department.payrun_processed == 'yes'" style="color: rgb(29, 104, 167);">{{department.name}} ({{department.employee_count}})</span><span v-else>{{department.name}} ({{department.employee_count}})</span> <b-icon v-if="department.payrun_processed == 'yes'" icon="check-circle-fill" class="ml-3 mt-1 float-right" variant="success"></b-icon></b-form-checkbox>
							</template>
						</b-form-checkbox-group>
					</b-form-group>
				</template>
				<template v-else>
					<h3 style="font-size: 15px;padding-top: calc(0.375rem + 1px);padding-bottom: calc(0.375rem + 1px);text-align: left !important;line-height: 1.6;color: #004242;font-weight: 500;" class="mb-4 text-center">Please select fiscal year and month to get department list</h3>
				</template>
			</div>
			<div class="col-md-12 px-3 text-center department-checkbox mt-4" v-if="this.get_payrun_parameter && this.get_payrun_parameter == 'work_location'">
				<template v-if="this.year && this.month">
					<h3 style="font-size: 15px;margin: 0 !important;padding-top: calc(0.375rem + 1px);padding-bottom: calc(0.375rem + 1px);text-align: left !important;line-height: 1.6;color: #004242;font-weight: 500;" class="m-4 text-center">Please choose work locations</h3>
					<b-form-group label="" v-slot="{ ariaDescribedby }" class="px-3">
						<div class="department-select-all position-relative text-left px-2 custom-checkbox">
							<input type="checkbox" id="branchAll" v-model="selectAllBranch" class="custom-control-input" v-on:change="setDepartment()"/>
							<label class="custom-control-label" for="branchAll"><span>Select All</span></label>
						</div>
						<b-form-checkbox-group id="work_location" class="row" v-model="work_location" :aria-describedby="ariaDescribedby" name="work_location" v-on:change="setDepartment()">
							<template v-for="work_location in work_locations">
								<b-form-checkbox class="col-md-6 mr-0" v-if="work_location.has_employee == 'no'" :value="work_location.id" :key="work_location.id" disabled><span v-if="work_location.payrun_processed == 'yes'" style="color: rgb(29, 104, 167);">{{work_location.name}} ({{work_location.employee_count}})</span><span v-else>{{work_location.name}} ({{work_location.employee_count}})</span> <b-icon v-if="work_location.payrun_processed == 'yes'" icon="check-circle-fill" class="ml-3 mt-1 float-right" variant="success"></b-icon><b-icon class="ml-2" icon="info-circle"  title="This work location does not have any employee assigned" v-b-tooltip></b-icon></b-form-checkbox>
								<b-form-checkbox class="col-md-6 mr-0" v-else :value="work_location.id" :key="work_location.id"><span v-if="work_location.payrun_processed == 'yes'" style="color: rgb(29, 104, 167);">{{work_location.name}} ({{work_location.employee_count}})</span><span v-else>{{work_location.name}} ({{work_location.employee_count}})</span> <b-icon v-if="work_location.payrun_processed == 'yes'" icon="check-circle-fill" class="ml-3 mt-1 float-right" variant="success"></b-icon></b-form-checkbox>
							</template>
						</b-form-checkbox-group>
					</b-form-group>
				</template>
				<template v-else>
					<h3 style="font-size: 15px;padding-top: calc(0.375rem + 1px);padding-bottom: calc(0.375rem + 1px);text-align: left !important;line-height: 1.6;color: #004242;font-weight: 500;" class="mb-4 text-center">Please select fiscal year and month to get work location list</h3>
				</template>
			</div>
		</div>

		<!-- <div class="row no-margin justify-content-center align-items-center" v-if="this.get_payrun_parameter && this.get_payrun_parameter == 'department'">
			<div class="col-md-6 float-left px-3 text-center department-checkbox">
				<h3  style='font-size:24px;' class="m-4 text-center">Please choose departments</h3>
				<b-form-group label="" v-slot="{ ariaDescribedby }">
					<b-form-checkbox-group id="department" class="row" v-model="department" :aria-describedby="ariaDescribedby" name="department" v-on:change="setDepartment()">
						<template v-for="department in departments">
                            <b-form-checkbox class="col-md-6 mr-0" v-if="department.has_employee == 'no'" :value="department.id" :key="department.id" disabled><span v-if="department.payrun_processed == 'yes'" style="color: rgb(29, 104, 167);">{{department.name}}</span><span v-else>{{department.name}}</span> <b-icon v-if="department.payrun_processed == 'yes'" icon="check-circle-fill" class="ml-3 mt-1 float-right" variant="success"></b-icon><b-icon class="ml-2" icon="info-circle"  title="This department does not have any employee assigned" v-b-tooltip></b-icon></b-form-checkbox>
                            <b-form-checkbox class="col-md-6 mr-0" v-else :value="department.id" :key="department.id"><span v-if="department.payrun_processed == 'yes'" style="color: rgb(29, 104, 167);">{{department.name}}</span><span v-else>{{department.name}}</span> <b-icon v-if="department.payrun_processed == 'yes'" icon="check-circle-fill" class="ml-3 mt-1 float-right" variant="success"></b-icon></b-form-checkbox>
                        </template>
					</b-form-checkbox-group>
				</b-form-group>
			</div>
		</div> -->
		<!-- <div class="row no-margin justify-content-center align-items-center" v-if="this.get_payrun_parameter && this.get_payrun_parameter == 'work_location'">
			<div class="col-md-6 float-left px-3 text-center department-checkbox">
				<h3  style='font-size:24px;' class="m-4 text-center">Please choose work locations</h3>
				<b-form-group label="" v-slot="{ ariaDescribedby }">
					<b-form-checkbox-group id="work_location" class="row" v-model="work_location" :aria-describedby="ariaDescribedby" name="work_location" v-on:change="setDepartment()">
						<template v-for="work_location in work_locations">
                            <b-form-checkbox class="col-md-6 mr-0" v-if="work_location.has_employee == 'no'" :value="work_location.id" :key="work_location.id" disabled><span v-if="work_location.payrun_processed == 'yes'" style="color: rgb(29, 104, 167);">{{work_location.name}}</span><span v-else>{{work_location.name}}</span> <b-icon v-if="work_location.payrun_processed == 'yes'" icon="check-circle-fill" class="ml-3 mt-1 float-right" variant="success"></b-icon><b-icon class="ml-2" icon="info-circle"  title="This work location does not have any employee assigned" v-b-tooltip></b-icon></b-form-checkbox>
                            <b-form-checkbox class="col-md-6 mr-0" v-else :value="work_location.id" :key="work_location.id"><span v-if="work_location.payrun_processed == 'yes'" style="color: rgb(29, 104, 167);">{{work_location.name}}</span><span v-else>{{work_location.name}}</span> <b-icon v-if="work_location.payrun_processed == 'yes'" icon="check-circle-fill" class="ml-3 mt-1 float-right" variant="success"></b-icon></b-form-checkbox>
                        </template>
					</b-form-checkbox-group>
				</b-form-group>
			</div>
		</div> -->
	</form>

  </div>

</template>

<script>
	export default{
		props: [ 'company_name', 'current_fiscal_year','current_month'],
		mounted() {
			console.log('started..');
		},
		data(){
			return {

				payrunsfiscalyear: [],
				payrunyears: [],
				payrun_type: 0,
				year_segment1:'',
				year_segment2:'',

				///////new payrun components starts////
				success: '',
				id: '',
				month: this.current_month,
				year: this.current_fiscal_year,
				loading:'',
				///////new payrun components end////

				departments: [],
				work_locations: [],
				department:[],
				work_location:[],

			}
		},
		methods:{

			sendMessagetoParent: function()
			{
				this.getDepartmentData();
				this.getWorkLocationData();
				this.$emit('childToParent', this.year, this.month, this.department, this.work_location);
			},

			setDepartment: function()
			{
				this.$emit('childToParent', this.year, this.month, this.department, this.work_location);
			},

			getDepartmentData: function(payrun_id)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/payrun/department/list/'+payrun_id , {
                    params: {
                        fiscal_year: this.year,
                        month: this.month
                    }
                }).then(function(response){
                    this.departments = response.data;

                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },

			getWorkLocationData: function(payrun_id)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/payrun/worklocation/list/'+payrun_id , {
                    params: {
                        fiscal_year: this.year,
                        month: this.month
                    }
                }).then(function(response){
                    this.work_locations = response.data;

                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },


			getpayrunyears: function()
			{

						axios.get(this.$api_url+'/getpayrun-years' , {
							params: {
								page: 1,
								per_page: 10,
								search_query: this.search,
								search_query_by_id: '',
							}
					}).then(function(response){
					this.payrunyears = response.data;


				}.bind(this));
			},




			setfiscalyear: function()
			{
				var yr=this.year.split("-");
				this.year_segment1=yr[0];
				this.year_segment2=yr[1];
				//alert(yr[0]);

				this.getDepartmentData();
				this.getWorkLocationData();
				this.sendMessagetoParent();

			},



				formSubmit(e) {

				e.preventDefault();

				let currentObj = this;

				this.loading='load';

				const config = {

					headers: { 'content-type': 'multipart/form-data' }

				}



				let formData = new FormData();

				var payslip_type='';

				if(this.payrun_type==1)
				payslip_type='?payslip_type=off_cycle'

				axios.get(this.$api_url+'/salary-slips-company/'+this.month+'/'+this.year+'/0'+payslip_type, formData, config)

				.then(function (response) {

					currentObj.success = response.data.success;
					currentObj.setSearch();
					currentObj.loading='';
					currentObj.$bvModal.hide('payrun_modal');

				})

				.catch(function (error) {

					currentObj.output = error;

				});

			},



			getpayrunsfiscalyear: function()
			{

						axios.get(this.$api_url+'/list-payruns-fiscalyear/0' , {
							params: {
								page: 1,
								per_page: 100,
								search_query: '',
								search_query_by_id: '',
							}
					}).then(function(response){
					this.payrunsfiscalyear = response.data.data;


				}.bind(this));
			},




		},

		created: function(){

			this.getpayrunsfiscalyear();
			this.getpayrunyears();
			this.year = this.getCurrentFinancialYear();
			this.setfiscalyear();
			this.getDepartmentData();
			this.getWorkLocationData();

		},

		computed: {
            get_payrun_parameter(){
                let urlParams = new URLSearchParams(window.location.search);
                let myParam = urlParams.get('payrun_for');

                return myParam;
            },

			selectAll: {
                get: function () {
                    //return this.payslips ? this.payslipids.length == this.payslips.length : false;
                },
                set: function (value) {
                    var departmentids = [];
                    if (value) {
                        this.departments.forEach(function (department) {
                            if(department.has_employee == 'yes'){
                                departmentids.push(department.id);
                            }
                        });
                    }
                    this.department = departmentids;
                }
            },

			selectAllBranch: {
                get: function () {
                    //return this.payslips ? this.payslipids.length == this.payslips.length : false;
                },
                set: function (value) {
                    var work_location_ids = [];
                    if (value) {
                        this.work_locations.forEach(function (work_location) {
                            if(work_location.has_employee == 'yes'){
                                work_location_ids.push(work_location.id);
                            }
                        });
                    }
                    this.work_location = work_location_ids;
                }
            },
        }
	}
</script>
<style>
  button.disabled{
	  cursor: default;
  }

  .tb-border{
    border: 1px solid #808080;
    border-radius: 0.25rem !important;
    border-collapse: separate;
}

.tb-border td{
    padding: 2px !important;
}

</style>
